import FieldResponseModel from '../models/FieldResponseModel'
import RecordModel from '../models/RecordModel'
import StageModel from '../models/StageModel'
import TemplateModel from '../models/TemplateModel'
import FieldsStore from '../store/FieldsStore'
import { Record, Template } from '../types'
import {
   UnionFieldModelType,
   UnionFieldResponse,
   UnionFieldResponseModel
} from '../types/Field'

class RecordUtils {
   static createRecordModel(
      recordId: string,
      template: TemplateModel
   ): RecordModel {
      return new RecordModel(recordId, template, [] as StageModel[]) // TODO: add stages
   }

   static updateRecordModel(recordModel: RecordModel, record: Record) {
      record.gofResponses.map(gofResponse => {
         recordModel.createOrUpdateGOFResponse(gofResponse)
         gofResponse.fieldResponses.map(fieldResponse => {
            recordModel.createOrUpdateFieldResponse(
               gofResponse.gofId,
               gofResponse.gofResponseId,
               fieldResponse
            )
         })
      })
   }

   static updateTemplateModel(
      templateModel: TemplateModel,
      template: Template
   ) {
      if (template.name) templateModel.name = template.name
      template.gofs.map(gof => {
         templateModel.createOrUpdateGOF(gof)

         gof.fields.map(field => {
            templateModel.createOrUpdateField(gof.gofId, field)
         })
      })
   }

   static createFieldResponseModelWithoutGOFResponse(
      fieldResponse: UnionFieldResponse,
      fieldModel: UnionFieldModelType
   ): UnionFieldResponseModel {
      return new FieldResponseModel<any, any, any>( //FIXME: unable to add types here
         fieldResponse.fieldResponseId,
         fieldResponse.response,
         fieldModel
      )
   }

   static getGoFResponseId(recordId: string, gofId: string): string {
      return `${recordId}-${gofId}`
   }

   private static getFieldResponseWithFieldId(
      fieldId: string,
      fieldResponseModels: Array<UnionFieldResponseModel>
   ): UnionFieldResponseModel | undefined {
      return fieldResponseModels.find(
         fieldResponse => fieldResponse.field.fieldId === fieldId
      )
   }
   static findVisibleFields(
      getField: (fieldId: string) => UnionFieldModelType
   ) {
      return (fieldIds: Array<string>) => (
         fieldResponseModels: Array<UnionFieldResponseModel>
      ) =>
         fieldIds.reduce(
            (visibleFields: UnionFieldModelType[], fieldId: string) => {
               const field = getField(fieldId)
               visibleFields.push(field)

               const response = RecordUtils.getFieldResponseWithFieldId(
                  fieldId,
                  fieldResponseModels
               )?.response

               if (field.fieldType === 'FIELDS_SELECTOR' && response) {
                  const dependentFieldIds = field.getFieldIdsWithOption(
                     response as string
                  )
                  visibleFields.push(
                     ...RecordUtils.findVisibleFields(getField)(
                        dependentFieldIds
                     )(fieldResponseModels)
                  )
               }
               return visibleFields
            },
            []
         )
   }
}

export default RecordUtils
